import React from 'react'
import { Button } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { Image } from '@/atoms/Image'
import { EyebrowMD, EyebrowSM, HeadingXS, LabelMD, LabelSM, ParagraphMD, ParagraphSM, TitleMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

interface ConfirmationStepProps {
  onClose: () => void
  ticketQuantity: number
  projectName: string
}

export const CompletionStep = ({ onClose, ticketQuantity, projectName }: ConfirmationStepProps) => {
  const { t } = useTranslate('common')

  return (
    <>
      <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-black/10 p-1.5" onClick={onClose}>
        <CloseIcon color="black" size={18} />
      </div>
      <FlexColumn className="gap-8">
        <FlexColumn>
          <Image
            src="/v1746133368/tickets-heart-ill-01_o0qqyo.webp"
            className="h-[100px] w-auto object-contain md:h-32"
            width={102}
            height={62}
            alt="Shining Generosity"
          />

          <FlexColumn className="gap-3">
            <FlexColumn className={'gap-1'}>
              <EyebrowMD className={'hidden pt-6 md:block'} weight={'semibold'}>
                {t('ticketQuantityGifted', `{{ ticketQuantity }} Guild Tickets Gifted`, {
                  ticketQuantity: ticketQuantity,
                })}
              </EyebrowMD>
              <EyebrowSM className={'pt-6 md:hidden'} weight={'semibold'}>
                {t('ticketQuantityGifted', `{{ ticketQuantity }} Guild Tickets Gifted`, {
                  ticketQuantity: ticketQuantity,
                })}
              </EyebrowSM>
              <HeadingXS weight="bold" className="hidden md:block">
                {t('giftYourGenerosityShines', 'Your Generosity Shines')}
              </HeadingXS>
              <TitleMD weight={'bold'} className={'md:hidden'}>
                {t('giftYourGenerosityShines', 'Your Generosity Shines')}
              </TitleMD>
            </FlexColumn>

            <ParagraphMD weight={'medium'} className={'hidden md:block '} color={'gray-700'}>
              {t(
                'giftedTicketsThankYou',
                `Thank you for generously gifting your Guild tickets to someone who may not otherwise see {{ projectName }} in theaters! Thank you for Paying it Forward.`,
                {
                  projectName: projectName,
                },
              )}
            </ParagraphMD>
            <ParagraphSM weight={'medium'} className={'md:hidden'} color={'gray-700'}>
              {t(
                'giftedTicketsThankYou',
                `Thank you for generously gifting your Guild tickets to someone who may not otherwise see {{ projectName }} in theaters! Thank you for Paying it Forward.`,
                {
                  projectName: projectName,
                },
              )}
            </ParagraphSM>
          </FlexColumn>
        </FlexColumn>
      </FlexColumn>

      <FlexColumn className="pt-6 md:pt-10">
        <FlexColumn className=" items-center justify-center">
          <Button
            onClick={onClose}
            className="font-color-black w-full items-center gap-1.5 rounded-[0.875rem] px-5 py-3 text-sm font-medium md:w-auto"
            variant="black"
          >
            <LabelSM className={'md:hidden'}>{t('closeBtn', 'Close')}</LabelSM>
            <LabelMD className={'hidden md:block'}>{t('closeBtn', 'Close')}</LabelMD>
          </Button>
        </FlexColumn>
      </FlexColumn>
    </>
  )
}
